<template>
  <BaseModalFullSize name="modal-pending-documentation" size="lg" title="" centered hide-header hide-footer>
    <div>
      <button type="button" aria-label="Close" class="close" @click="closeModal">×</button>
    </div>
    <div class="d-flex flex-row">
      <!-- Texto -->
      <div style="width:65%;padding: 2.5rem !important">
        <h2>Envie seus dados financeiros para habilitar as vendas dos seus produtos</h2>
        <p>Para começar a vender, é <strong>obrigatório</strong> enviar seus dados financeiros. Enquanto sua documentação estiver em análise, as vendas ficarão indisponíveis. Nossa equipe revisará suas informações e realizará a aprovação do cadastro em até 48 horas.</p>
        <div class="d-flex justify-content-between">
          <b-button @click="openPendingDocumentationScreen" class="btn btn-primary d-flex flex-row justify-content-between" style="gap:10px;" variant="primary">
            <img class="icon-document-up align-self-center" src="@/assets/img/icons/document-up.svg"></img>
            Enviar documentação
          </b-button>
          <b-button @click="closeModal" variant="secondary">Deixar para depois</b-button>
        </div>
      </div>
      <!-- Imagem -->
      <div style="width:35%;overflow:hidden;">
        <img src="@/assets/img/man-at-office.jpeg" class="img-fluid" alt="Descrição da imagem" />
      </div>
    </div>
  </BaseModalFullSize>
</template>

<script>
export default {
  name: 'ModalPendingDocumentation',
  data() {
    return {
      loading: false
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('modal-pending-documentation');
    },
    openPendingDocumentationScreen() {
      this.$router.push("/minha-conta");
    },
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.4rem;
  margin-bottom: 1rem;
}

p {
  font-size: 0.95rem;
  margin-bottom: 2rem !important;
}

.close{
  position: absolute;
  top: 10px;
  right: 10px;
  color:white;
}
.modal-dialog.modal-lg {
  max-width: 900px;
  border-radius: 8px;
}

.img-fluid {
  object-fit: cover;
  height: 100%;
}
</style>
